<template>
  <div>
    <!-- <img src="http://127.0.0.1:8000/storage/svgs/us-open-22.svg" style="width:100%;float:left;" /> -->
    <CRow v-if="$store.state.user" class="mb-2">
      <CCol sm="12" class="p-0 text-center">
        <a
          class="btn btn-sm btn-primary mx-1"
          href="https://paiworkflow.com"
          target="_blank"
          rel="noopener noreferrer"
        >Link To Workflow</a>
        <a
          class="btn btn-sm btn-primary mx-1"
          href="https://app.air.inc/a/bT2dcDudx/b/44552d9c-89ae-45e4-b13f-305d0d5b3843"
          target="_blank"
          rel="noopener noreferrer"
        >Link To Air</a>
        <a
          class="btn btn-sm btn-primary mx-1"
          href="https://studio.imperial1916.com"
          target="_blank"
          rel="noopener noreferrer"
        >Link To Studio</a>
      </CCol>
    </CRow>
    <CRow v-if="$store.state.user">
      <CCol sm="12">
        <CCard>
          <CCardBody style="text-align:center;">
            <label style="color:grey;">CSR Dashboard Showing</label>
            <v-select v-if="csrs" @input="csrChanged()" style="width:300px;margin-left:auto;margin-right:auto;" v-model="csr_selected" :options="csrs" label="name"></v-select>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    
    
    <CRow v-if="csr_selected && !csrLoading">
      <!-- <CCol sm="3" lg="3">
        <new-orders-widget @set="typeSet" :csr="csr_selected"></new-orders-widget>
      </CCol> -->
      <div style="width:100%;float:left;" v-show="!widgetsLoading">
        <!-- <CCol class="float-left" sm="3" lg="3">
          <open-orders-widget @set="typeSet" :csr="csr_selected"></open-orders-widget>
        </CCol> -->
        <CCol class="float-left" sm="3" lg="3">
          <orders-waiting-on-customer @set="typeSet" :csr="csr_selected"></orders-waiting-on-customer>
        </CCol>
        <CCol class="float-left" sm="3" lg="3" v-if="orders_waiting_on_customer">
          <csr-queue @set="typeSet" :csr="csr_selected"></csr-queue>
        </CCol>
        <CCol class="float-left" sm="3" lg="3" v-if="csr_queue">
          <saved-orders-widget @set="typeSet" :csr="csr_selected"></saved-orders-widget>
        </CCol>
      </div>
      <small-loader v-show="widgetsLoading" />
    </CRow>
    <!-- <CRow v-if="csr_selected && !csrLoading && csr_queue">
      <CCol sm="12">
        <search-orders :csr="csr_selected"></search-orders>
      </CCol>
    </CRow> -->

    <!-- Open Orders Table -->
    <CRow v-if="csr_selected && !csrLoading">
      <csr-open-orders @set="typeSet" :csr="csr_selected" />
    </CRow>


    <CRow v-if="$store.state.user">
      <csr-table :fromDash="true"></csr-table>
    </CRow>
    <CRow v-if="$store.state.user">
      <order-history :fromDash="true"></order-history>
    </CRow>
    <CRow v-if="csr_selected && !csrLoading && csr_queue">
      <CCol class="align-items-stretch" sm="12" md="6">
        <upcoming-orders type="ship_date" title="Orders Needing Shipped < 7 Days" :csr="csr_selected"></upcoming-orders>
      </CCol>
      <CCol class="align-items-stretch" sm="12" md="6">
        <upcoming-orders type="event_date" title="Upcoming Event Orders < 30 Days" :csr="csr_selected"></upcoming-orders>
      </CCol>
    </CRow>
    <CRow v-if="csr_selected && !csrLoading && csr_queue">
      <CCol class="align-items-stretch" sm="12" md="12">
        <rep-chart-dash :csr="csr_selected"></rep-chart-dash>
      </CCol>
    </CRow>
    <CRow v-if="csrLoading || loading">
      <small-loader></small-loader>
    </CRow>
    <!-- <CRow>
      <csr-table></csr-table>
    </CRow> -->
  </div>
</template>

<script>
import NewOrdersWidget from './new_orders_widget'
import OpenOrdersWidget from './open_orders_widget'
import OrdersWaitingOnCustomer from './orders_waiting_on_customer_widget'
import OrderHistory from './order_history'
// import OrdersNotifyWidget from './orders_notify_widget'
import CsrTable from './../orders/csr_table'
import RepChartDash from './../components/rep_chart_dash'
import UpcomingOrders from './../components/upcoming_orders'
import SearchOrders from './../components/search_orders'
import SavedOrdersWidget from './../components/saved_orders_widget'
import CsrQueue from './../components/csr_queue'
import CsrOpenOrders from './csr_open_orders.vue'
var methods = {}

methods.color = function (value) {
  let $color
  if (value <= 25) {
    $color = 'info'
  } else if (value > 25 && value <= 50) {
    $color = 'success'
  } else if (value > 50 && value <= 75) {
    $color = 'warning'
  } else if (value > 75 && value <= 100) {
    $color = 'danger'
  }
  return $color
}

methods.typeSet = function (val) {
  this[val] = true

  this.widgetsLoading = false
}

methods.getCsrs = function () {
  axios.get(this.$apiAdress + '/api/getAllCsrs?token=' + localStorage.getItem('api_token')).then(response => {
    console.log(response)
    this.csrs = response.data
    var that = this
    this.csrs.forEach(function (val) {
      if (val.id === that.$store.state.user.id) {
        that.csr_selected = val
      }
    })
  })
}

methods.csrChanged = function () {
  console.log('changed')
  this.csrLoading = true
  var that = this
  setTimeout(function () {
    that.csrLoading = false
  }, 500)
}

export default {
  name: 'CSRDashboard',
  components: {
    NewOrdersWidget,
    OpenOrdersWidget,
    OrdersWaitingOnCustomer,
    CsrTable,
    RepChartDash,
    UpcomingOrders,
    SearchOrders,
    SavedOrdersWidget,
    CsrQueue,
    OrderHistory,
    CsrOpenOrders
  },
  data () {
    return {
      csrs: null,
      csr_selected: null,
      csrLoading: false,
      customer_selected: null,
      new_orders_widget: false,
      open_orders_widget: false,
      orders_notify_widget: false,
      saved_orders_widget: false,
      orders_waiting_on_customer: false,
      csr_queue: false,
      loading: true,
      widgetsLoading: true
    }
  },
  mounted: function () {
    this.getCsrs()
  },
  methods: methods
}
</script>
